import {
    createErrorToast,
    createInfoToast,
    createSuccessToast,
    createWarningToast
} from "./toast-messages/toast-messages.js";

/**
 * @typedef {Partial<ToastMessage>} AlertOptions
 * @property {Boolean | undefined} useToasts
 */

/**
 * @param {string} message
 * @param {AlertOptions} options
 * @return {ToastMessage|void}
 */
export const successAlert = (message, options= {}) => {
    if (options.useToasts !== false) {
        return createSuccessToast(message, options);
    }
    if (window.toastr) {
        return window.toastr.success(message);
    }
    if (window.alertify) {
        return window.alertify.success(message);
    }
}

export const successAlerts = (...messages) => {
    for (let message of messages) {
        successAlert(message);
    }
}

/**
 * @param {string} message
 * @param {AlertOptions} options
 * @return {ToastMessage|void}
 */
export const errorAlert = (message, options = {}) => {
    if (options.useToasts !== false) {
        return createErrorToast(message, options);
    }
    if (window.toastr) {
        return window.toastr.error(message);
    }
    if (window.alertify) {
        return window.alertify.error(message);
    }
}

export const errorAlerts = (...messages) => {
    for (let message of messages) {
        errorAlert(message);
    }
}

/**
 * @param {string} message
 * @param {AlertOptions} options
 * @return {ToastMessage|void}
 */
export const warningAlert = (message, options = {}) => {
    if (options.useToasts !== false) {
        return createWarningToast(message, options);
    }
    if (window.toastr) {
        return window.toastr.warning(message);
    }
    if (window.alertify) {
        return window.alertify.warning(message);
    }
}

export const warningAlerts = (...messages) => {
    for (let message of messages) {
        warningAlert(message);
    }
}

/**
 * @param {string} message
 * @param {AlertOptions} options
 * @return {ToastMessage}
 */
export const infoAlert = (message, options = {}) => {
    return createInfoToast(message, {
        icon: 'info-circle',
        ...options,
    });
}

export const showAlertToasts = (...messages) => {
    let type;
    for (let message of messages) {
        type = String(message.type).toLowerCase();
        if (type === 'error' || type === 'danger') {
            createErrorToast(message.content);
        } else if (type === 'warning') {
            createWarningToast(message.content);
        } else if (type === 'success') {
            createSuccessToast(message.content);
        } else {
            createInfoToast(message.content);
        }
    }
}
